import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";

@Component({
  selector: "app-restricted-access",
  templateUrl: "./restricted-access.component.html",
  styleUrls: ["./restricted-access.component.scss"],
})
export class RestrictedAccessComponent implements OnInit {
  allUsers: any;
  tempUsers: any;
  // Add a separate array to track selected users
  selectedUsers: any[] = [];
  // Pagination state
  currentPage: number = 1;
  usersPerPage: number = 5;
  totalPages: number = 1;
  startIndex: number = 0;
  endIndex: number = 0;
  paginatedUsers: any[] = [];
  visiblePageNumbers: (number | string)[] = [];
  userData: any;
  profilePicture: string;
  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  showDefaultImage: boolean;
  input: string = "";
  isdisabled: boolean;
  flowModel: any;
  _steps: any[];
  coverImageUri: string;
  stepsImageUri: string;
  stepDescription: string;
  title: string;
  CategoryName: string;
  inames: any[];
  accessType: string;
  description: string;
  userDisplayName: any;
  showUsers: boolean;
  noResultReturned: boolean;
  isSearching: boolean = false;
  flowData: any;
  private searchTerms = new Subject<string>();

  constructor(
    private userserviceService: UserserviceService,
    private router: Router,

    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    public dialogRef: MatDialogRef<RestrictedAccessComponent>
  ) {
    this.flowModel = JSON.parse(localStorage.getItem("flowModel"));
    this.searchTerms
      .pipe(debounceTime(2000)) // Adjust the debounce time as needed
      .subscribe(() => {
        // Call your search function here
        this.performUsersSearch(0);
      });
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.flowData = JSON.parse(localStorage.getItem("flowModel"));
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }
    localStorage.getItem("flowmodel");
    //
    this.allUsers = [];
    this.tempUsers = [];
    this.selectedUsers = []; // Initialize selected users array
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    this.getPaginatedUsers(undefined, "0");
    
    // Check if there are existing restricted users and initialize selectedUsers
    if (this.flowData && this.flowData.restrictedAccessFlows && this.flowData.restrictedAccessFlows.length > 0) {
      this.initializeSelectedUsersFromRestricted();
    }
  }
  performUsersSearch(pageIndex) {
    this.noResultReturned = true;
    this.isSearching = true;
    
    // Don't clear selectedUsers - we want to accumulate selections
    // this.preserveSelectedUsers();
    
    this.allUsers = [];
    this.tempUsers = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      this.showUsers = false;
      email = this.userData.emailAddress;
    }
    this.showUsers = true;
    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.userserviceService.searchInUsers(flowQueryModel).subscribe(
      (data) => {
        this.noResultReturned = false;

        if (data.allUsers.length > 0) {
          this.tempUsers = [];
          this.allUsers = [];
          data.allUsers.forEach((element) => {
            console.log(element);
            const user = {
              user: element,
              showFollow: false,
              followButtonText: element.followingText,
              EmailAddress: element.emailAddress,
            };
            this.allUsers.push(user);
          });

          this.tempUsers = this.allUsers;
          console.log(this.tempUsers);
          this.tempUsers.forEach((element) => {
            if (element.followButtonText === "Following") {
              element.followButtonText = "Following";
              element.followingcolor = "black";
              element.followingbgcolor = "white";
            } else {
              element.followButtonText = "Follow";
              element.followingcolor = "white";
              element.followingbgcolor = "#5ea1d8";
            }
          });

          // Check if any of the new search results are already selected
          this.checkForExistingSelections();
        } else {
          this.tempUsers = [];
        }

        // Reset to first page on new search and update pagination
        this.currentPage = 1;
        this.updatePagination();
        this.isSearching = false;
      },
      (error) => {
        this.isSearching = false;
        this.noResultReturned = false;
        this.tempUsers = [];
        this.allUsers = [];
        this.updatePagination();
      }
    );
  }
  getPaginatedUsers(infiniteScroll, pageIndex) {
    var email = "";

    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performUsersSearch(pageIndex);
    } else {
      this.isSearching = true;
      this.userserviceService.getAllUsers(flowQueryModel).subscribe(
        (data) => {
          if (data.allUsers.length > 0) {
            this.tempUsers = [];
            this.allUsers = [];
            data.allUsers.forEach((element) => {
              const user = {
                FlowId: element.rowKey,
                user: element,
                UserName: element.userName,
                ProfilePicUrl: element.profilePicUrl,
                FirstName: element.firstName,
                EmailAddress: element.emailAddress,
                showFollow: false,
                followButtonText: element.followingText,
              };
              this.allUsers.push(user);
            });
            this.tempUsers = this.allUsers;
            console.log(this.tempUsers);
            this.tempUsers.forEach((element) => {
              if (element.followButtonText === "Following") {
                element.followButtonText = "Following";
                element.followingcolor = "black";
                element.followingbgcolor = "white";
              } else {
                element.followButtonText = "Follow";
                element.followingcolor = "white";
                element.followingbgcolor = "#5ea1d8";
              }
            });

                      // Check if any of the loaded users are already selected
          this.checkForExistingSelections();
          } else {
            this.tempUsers = [];
            this.allUsers = [];
          }

          // Update pagination after loading users
          this.currentPage = 1;
          this.updatePagination();
          this.isSearching = false;
        },
        (error) => {
          this.isSearching = false;
          this.tempUsers = [];
          this.allUsers = [];
          this.updatePagination();
        }
      );
      this.showUsers = true;
    }
  }

  getAllUsers() {
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    // Don't clear selectedUsers - we want to accumulate selections
    // this.preserveSelectedUsers();
    
    this.allUsers = [];
    this.tempUsers = [];
    this.currentPage = 1;
    this.getPaginatedUsers(undefined, "0");
    console.log(this.tempUsers);
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }
  publish() {
    this.noResultReturned = true;
    //
    if (this.userData != null) {
      // Get all selected users from both arrays
      const selectedUsers = this.getSelectedUsers();
      console.log('Selected users:', selectedUsers);
      console.log('All users:', this.allUsers);
      
      this.flowModel.restrictedAccessFlows = selectedUsers;
      this.flowModel.searchKeyWords =
        this.flowModel.searchKeyWords &&
        this.flowModel.searchKeyWords.length > 0
          ? this.flowModel.searchKeyWords
          : "";
      this.flowServiceService
        .publishUserFlow(this.flowModel, this.userData.emailAddress)
        .subscribe((data) => {
          this.close(data);

          this.noResultReturned = false;
        });
    }
  }
  close(data) {
    this.dialogRef.close(data);
  }

  viewUserProfile(selectedUser) {
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedUser.customerEmail ||
        this.userData.emailAddress === selectedUser.emailAddress
      ) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedUser);
    } else {
      this.router.navigate(["/login"]);
    }
  }

  searchUsers() {
    // Reset to first page on new search and debounce
    this.currentPage = 1; 
    
    // If search input is cleared, restore all users with their selection state
    if (!this.input || this.input.trim() === '') {
      this.getAllUsers();
    } else {
      this.searchTerms.next(this.input);
    }
  }

  accessChanged() {
    // Update selectedUsers array based on current selections
    this.updateSelectedUsersArray();
    
    // Check if any users are selected
    const hasSelectedUsers = this.selectedUsers && this.selectedUsers.length > 0;
    
    if (!hasSelectedUsers) {
      this.isdisabled = true;
    } else {
      this.isdisabled = false;
    }
  }

  // New method to handle when a user is deselected via checkbox
  onUserSelectionChange(user: any, isSelected: boolean) {
    if (isSelected) {
      // User was selected - add to selectedUsers if not already there
      const email = user.user?.emailAddress || user.EmailAddress;
      const exists = this.selectedUsers.some(selected => selected.emailAddress === email);
      
      if (!exists) {
        this.selectedUsers.push({
          emailAddress: email,
          userName: user.user?.userName || user.UserName,
          profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
          firstName: user.user?.firstName || user.FirstName,
          IsAccessGiven: true
        });
      }
    } else {
      // User was deselected - remove from selectedUsers
      const email = user.user?.emailAddress || user.EmailAddress;
      this.selectedUsers = this.selectedUsers.filter(selected => selected.emailAddress !== email);
    }
    
    this.accessChanged();
  }

  // New method to check if any users in current results are already selected
  private checkForExistingSelections() {
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.selectedUsers.forEach(selectedUser => {
        // Find the user in the current allUsers array and restore their selection
        const existingUser = this.allUsers.find(user => 
          (user.user?.emailAddress === selectedUser.emailAddress) || 
          (user.EmailAddress === selectedUser.emailAddress)
        );
        
        if (existingUser) {
          if (existingUser.user) {
            existingUser.user.IsAccessGiven = true;
          } else {
            existingUser.IsAccessGiven = true;
          }
        }
      });
    }
  }

  private updateSelectedUsersArray() {
    // Don't clear the array - we want to accumulate selections
    // this.selectedUsers = [];
    
    if (this.allUsers && this.allUsers.length > 0) {
      this.allUsers.forEach(user => {
        if (user?.user?.IsAccessGiven || user?.IsAccessGiven) {
          const email = user.user?.emailAddress || user.EmailAddress;
          // Check if user is already in selectedUsers
          const exists = this.selectedUsers.some(selected => selected.emailAddress === email);
          
          if (!exists) {
            this.selectedUsers.push({
              emailAddress: email,
              userName: user.user?.userName || user.UserName,
              profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
              firstName: user.user?.firstName || user.FirstName,
              IsAccessGiven: true
            });
          }
        }
      });
    }
    
    // Also check tempUsers for any selected users
    if (this.tempUsers && this.tempUsers.length > 0) {
      this.tempUsers.forEach(user => {
        if (user?.user?.IsAccessGiven || user?.IsAccessGiven) {
          // Check if user is already in selectedUsers
          const email = user.user?.emailAddress || user.EmailAddress;
          const exists = this.selectedUsers.some(selected => selected.emailAddress === email);
          
          if (!exists) {
            this.selectedUsers.push({
              emailAddress: email,
              userName: user.user?.userName || user.UserName,
              profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
              firstName: user.user?.firstName || user.FirstName,
              IsAccessGiven: true
            });
          }
        }
      });
    }
  }

  setRestrictedUsers() {
    if (
      this.flowModel.restrictedAccessFlows != null &&
      this.flowModel.restrictedAccessFlows != undefined
    ) {
      this.isdisabled = false;
      this.flowModel.restrictedAccessFlows.forEach((element) => {
        var userAccess = this.allUsers.filter(
          (x) => x.emailAddress == element.emailAddress
        )[0];
        if (userAccess) {
          if (userAccess.user) {
            userAccess.user.IsAccessGiven = true;
          } else {
            userAccess.IsAccessGiven = true;
          }
        }
      });

      this.allUsers = this.allUsers.sort((u) => u.IsAccessGiven).reverse();
      
      // Initialize selectedUsers array with existing restricted users
      this.initializeSelectedUsersFromRestricted();
    }
  }

  // New method to initialize selectedUsers from existing restricted users
  private initializeSelectedUsersFromRestricted() {
    if (this.flowModel.restrictedAccessFlows && this.flowModel.restrictedAccessFlows.length > 0) {
      this.selectedUsers = [];
      this.flowModel.restrictedAccessFlows.forEach((element) => {
        this.selectedUsers.push({
          emailAddress: element.emailAddress,
          userName: element.userName,
          profilePicUrl: element.profilePicUrl,
          firstName: element.firstName,
          IsAccessGiven: true
        });
      });
    }
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
        // Ensure pagination reflects any preloaded restrictions
        this.currentPage = 1;
        this.updatePagination();
      });
    }
  }

  // Pagination helpers
  private updatePagination() {
    if (!this.tempUsers || this.tempUsers.length === 0) {
      this.totalPages = 1;
      this.paginatedUsers = [];
      this.visiblePageNumbers = [];
      this.startIndex = 0;
      this.endIndex = 0;
      return;
    }

    this.totalPages = Math.ceil(this.tempUsers.length / this.usersPerPage);
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    this.currentPage = Math.max(this.currentPage, 1);

    this.startIndex = (this.currentPage - 1) * this.usersPerPage;
    this.endIndex = Math.min(
      this.startIndex + this.usersPerPage,
      this.tempUsers.length
    );

    this.paginatedUsers = this.tempUsers.slice(this.startIndex, this.endIndex);
    this.updateVisiblePageNumbers();
  }

  private updateVisiblePageNumbers() {
    this.visiblePageNumbers = [];
    if (this.totalPages <= 7) {
      for (let i = 1; i <= this.totalPages; i++) {
        this.visiblePageNumbers.push(i);
      }
    } else {
      if (this.currentPage <= 4) {
        for (let i = 1; i <= 5; i++) this.visiblePageNumbers.push(i);
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.totalPages - 4; i <= this.totalPages; i++)
          this.visiblePageNumbers.push(i);
      } else {
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++)
          this.visiblePageNumbers.push(i);
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      }
    }
  }

  // New methods to preserve and restore selected users
  private preserveSelectedUsers() {
    // Update the selectedUsers array before clearing
    this.updateSelectedUsersArray();
  }

  private restoreSelectedUsers() {
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      this.selectedUsers.forEach(selectedUser => {
        // Find the user in the current allUsers array and restore their selection
        const existingUser = this.allUsers.find(user => 
          (user.user?.emailAddress === selectedUser.emailAddress) || 
          (user.EmailAddress === selectedUser.emailAddress)
        );
        
        if (existingUser) {
          if (existingUser.user) {
            existingUser.user.IsAccessGiven = true;
          } else {
            existingUser.IsAccessGiven = true;
          }
        }
      });
    }
  }

  // Update the getSelectedUsers method to always return the selectedUsers array
  getSelectedUsers(): any[] {
    // Always return the selectedUsers array if it has items
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      return this.selectedUsers;
    }
    
    // Fallback to filtering from arrays if selectedUsers is empty
    const selectedFromAllUsers = this.allUsers?.filter((x) => x?.user?.IsAccessGiven || x?.IsAccessGiven) || [];
    const selectedFromTempUsers = this.tempUsers?.filter((x) => x?.user?.IsAccessGiven || x?.IsAccessGiven) || [];
    
    // Combine and deduplicate based on email address
    const allSelected = [...selectedFromAllUsers, ...selectedFromTempUsers];
    const uniqueSelected = [];
    const seenEmails = new Set();
    
    allSelected.forEach(user => {
      const email = user.user?.emailAddress || user.EmailAddress;
      if (email && !seenEmails.has(email)) {
        seenEmails.add(email);
        uniqueSelected.push(user);
      }
    });
    
    return uniqueSelected;
  }

  removeSelectedUser(u: any): void {
    // Remove from selectedUsers array - selectedUsers objects have flat structure
    const email = u.emailAddress;
    this.selectedUsers = this.selectedUsers.filter(user => user.emailAddress !== email);
    
    // Also uncheck the checkbox in the current view if the user is visible
    if (this.allUsers && this.allUsers.length > 0) {
      this.allUsers.forEach(user => {
        const userEmail = user.user?.emailAddress || user.EmailAddress;
        if (userEmail === email) {
          if (user.user) {
            user.user.IsAccessGiven = false;
          } else {
            user.IsAccessGiven = false;
          }
        }
      });
    }
    
    if (this.tempUsers && this.tempUsers.length > 0) {
      this.tempUsers.forEach(user => {
        const userEmail = user.user?.emailAddress || user.EmailAddress;
        if (userEmail === email) {
          if (user.user) {
            user.user.IsAccessGiven = false;
          } else {
            user.IsAccessGiven = false;
          }
        }
      });
    }
    
    this.accessChanged();
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  goToPage(page: number | string) {
    if (typeof page === "number" && page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
    }
  }
}
